export default {
  popupData: null,
  isShow: false,
  isLoading: {
    popup: false,
    save: false,
  },
  errors: {
    popup: null,
    save: null,
  },
};
